<template>
  <aside class="app-sidebar" :class="computedClass" :style="computedStyle">
    <ul class="app-sidebar__menu">
      <app-sidebar-link
        :minimized="minimized"
        :active-by-default="false"
        :icon="'entypo entypo-home'"
        :to="{ name: 'index' }"
        :title="'หน้าแรก'"

        class="mb-2 py-1"
        style="border-bottom: 1px solid #dfdfdf;"
      />

      <template v-for="(item, key) in items">
        <app-sidebar-link-group
          :key="key"
          :minimized="minimized"
          :icon="item.meta && item.meta.iconClass"
          v-if="item.children"
          :title="$t(item.displayName)"
          :children="item.children"
          :active-by-default="hasActiveByDefault(item)"
        >
          <app-sidebar-link
            v-for="(subMenuItem, key) in item.children"
            :key="key"
            :to="{ name: subMenuItem.name }"
            :title="$t(subMenuItem.displayName)"
          />
        </app-sidebar-link-group>
        <app-sidebar-link
          v-else
          :key="key"
          :minimized="minimized"
          :active-by-default="
            item.path === $route.path ||
              ($route.params.hasOwnProperty('brand') &&
              $route.params.brand == item.brand)
          "
          :icon="item.meta && item.meta.iconClass"
          :to="{ path: item.path }"
          :title="$t(item.displayName)"
        />
      </template>
    </ul>
  </aside>
</template>

<script>
/*eslint-disable */
import { navigationRoutes } from "./NavigationRoutes";
import AppSidebarLink from "./components/AppSidebarLink";
import AppSidebarLinkGroup from "./components/AppSidebarLinkGroup";
import { ColorThemeMixin } from "../../../services/vuestic-ui";

// Services API
import fs from "@/components/series/fs.js";

export default {
  name: "app-sidebar",
  inject: ["contextConfig"],
  components: {
    AppSidebarLink,
    AppSidebarLinkGroup,
  },
  mixins: [ColorThemeMixin],
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
    color: {
      type: String,
      default: "secondary",
    },
  },
  async mounted() {
    // Load form server (role)

    const role = await fs.call(`${this.$fs.api}/permission/all/index.php?code=${localStorage.getItem('_token')}`)

    const r = [];
    if (role) {
      // console.log(this.$route.params.brand, 'route')

      role.result.forEach((item) => {
        r.push({
          name: `series/list/${item.brand}`,
          path: `/series/list/${item.brand}`,
          displayName: `${item.name} (${item.brand})`,
          brand: item.brand,
          meta: {
            iconClass: "entypo entypo-record",
          },
        });
      });
    }

    this.items = r;
    // ????
  },
  data() {
    return {
      items: navigationRoutes.routes,
    };
  },
  computed: {
    computedClass() {
      return {
        "app-sidebar--minimized": this.minimized,
      };
    },
    computedStyle() {
      return {
        backgroundColor: this.contextConfig.invertedColor
          ? "white"
          : this.colorComputed,
      };
    },
  },
  methods: {
    hasActiveByDefault(item) {
      return item.children.some((child) => child.name === this.$route.name);
    },
  },
};
</script>

<style lang="scss">
.app-sidebar {
  overflow: auto;
  display: flex;
  max-height: 100%;
  flex: 0 0 16rem;

  @include media-breakpoint-down(sm) {
    flex: 0 0 100%;
  }

  &--minimized {
    // flex: 0 0 3.25rem;
    // ซ่อนตอน จอเล็ก
    flex: 0 0 0rem;
  }

  &__menu {
    margin-bottom: 0;
    // original
    // padding-top: 2.5625rem;
    // อันนี้แก้เอง (max)
    padding-top: 0rem;
    padding-bottom: 2.5rem;
    list-style: none;
    padding-left: 0;
    width: 100%;
  }
}
</style>
